import { render, staticRenderFns } from "./lista-buscador-presets-editar.vue?vue&type=template&id=2db2c201&scoped=true&"
import script from "./lista-buscador-presets-editar.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-presets-editar.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-presets-editar.vue?vue&type=style&index=0&id=2db2c201&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2c201",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VIcon,VItem,VItemGroup,VRow,VSpacer,VTextField,VTextarea})
